<template>
    <v-container>
        <v-skeleton-loader v-if="! helps" type="table"></v-skeleton-loader>

        <template v-else>
            <div class="text-right mb-4">
                <v-btn :to="{ name: 'help.create' }" rounded color="primary">
                    Buat baru
                </v-btn>
            </div>

            <v-data-table
                :headers="headers"
                :items="helps"
            >
                <template #item.content="{ value }">
                    {{ value.substring(0, 75) }}
                </template>

                <template #item.action="{ item }">
                    <v-btn
                        :to="{ name: 'help.edit', params: { help_id: item.id } }"
                        icon
                    >
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>

                    <v-btn @click="deleteConfirmation(item)" icon color="error">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </template>
            </v-data-table>

            <confirmation-dialog
                v-model="deleteDialog"
                @confirmed="deleteHelp"
                title="Hapus bantuan?"
                subtitle="Aksi tidak dapat dibatalkan"
                color="error"
                actionText="hapus"
            >
            </confirmation-dialog>
        </template>
    </v-container>
</template>

<script>
import ConfirmationDialog from '@/components/ConfirmationDialog'

export default {
    components: {
        ConfirmationDialog,
    },

    data() {
        return {
            helps: null,
            deleteDialog: false,
            selectedItem: null,
            headers: [
                {
                    text: 'Judul',
                    value: 'title'
                }, {
                    text: 'Konten',
                    value: 'content'
                }, {
                    text: '',
                    value: 'action'
                }
            ]
        }
    },

    methods: {
        getData() {
            this.$api.get('help', { loader: 'appbar' })
                .then(response => {
                    this.helps = response.data.helps
                })
        },

        deleteConfirmation(item) {
            this.selectedItem = item
            this.deleteDialog = true
        },

        deleteHelp() {
            this.$api.delete(`help/${this.selectedItem.id}`, { loader: 'appbar' })
                .then(response => {
                    if (response.data.deleted) {
                        this.$store.dispatch('flash/info', 'Bantuan dihapus')
                    } else {
                        this.$store.dispatch('flash/genericError')
                    }

                    this.selectedItem = null
                    this.getData()
                })
        },
    },

    created() {
        this.getData()
    }
}
</script>
